<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div
  [formGroup]="group"
  [id]="id"
  [attr.data-name]="model.name"
  [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
  (change)="onChange($event)"
>
  <profile-pds-p-radio-group
    p-radio-group
    [hideLabel]="false"
    direction="row"
    [ngClass]="getClass('element', 'option')"
    [formControlName]="model.id"
    [name]="model.name"
    [attr.aria-label]="model.legend || null"
  >
    @for (option of model.options$ | async; track option.value; let i = $index) {
      <profile-pds-p-radio-group-option
        p-radio-group-option
        [label]="option.label ?? undefined"
        [value]="option.value"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        [id]="model.name + i"
      ></profile-pds-p-radio-group-option>
    }
  </profile-pds-p-radio-group>
</div>
